// extracted by mini-css-extract-plugin
module.exports = {"scroll":"Embed_scroll__r8MF2","card":"Embed_card__3dQyL","cardImage":"Embed_cardImage__3HiOZ","cardTitle":"Embed_cardTitle__1zS4i"};